import { Button } from "@/components/ui/button"
import { Menu } from 'lucide-react'

type SiteHeaderProps = {
  onOpenSidebar: () => void
}

export function SiteHeader({ onOpenSidebar }: SiteHeaderProps) {
  return (
    <header className="flex items-center justify-between border-b border-border bg-card px-4 py-3 lg:hidden">
      <Button size="icon" variant="secondary"
  type="button"
  onClick={onOpenSidebar}
  aria-label="Open navigation"
  >
        <Menu className="size-4" />
      </Button>
      <span className="font-avenir text-section-title font-semibold text-foreground">OptiMist Admin</span>
      <div className="w-10" />
    </header>
  )
}
